import DocImg from "../../../../src/components/docs/doc-img";
import packingListAppAttributes from "../../../../src/assets/docs/dashboard/playout/packing-list-summer-special.png";
import * as React from 'react';
export default {
  DocImg,
  packingListAppAttributes,
  React
};